<button
  uiKitButton
  class="log-out-button"
  color="white"
  [withIcon]="true"
  size="small"
  [routerLink]="'/logout'"
  [gaEvent]="AnalyticsEventName.LogoutClick"
  testId="logout-button"
>
  <ui-kit-icon icon="log-out" size="small" color="secondary"></ui-kit-icon>
  Log Out
</button>
